import { Layout, Grid } from '@enterprise-ui/canvas-ui-react'
import { ReactNode } from 'react'
import { StyledFooterItems } from './styles'
import RoundelMediaDesignedBy from '../../assets/Roundel_Media_designed_by.svg'

interface FooterProps {
  termAndConditionsUrl?: string
  children?: ReactNode
}

const Footer = ({ termAndConditionsUrl, children }: FooterProps) => {
  const appName = 'Roundel Media Studio'

  return (
    <Layout.Footer>
      <Grid.Container align="center">
        <Grid.Item xs={6}>
          <RoundelMediaDesignedBy aria-label="Media designed by Target" />
        </Grid.Item>
        <Grid.Item xs={6}>
          <StyledFooterItems>
            <div className="hc8-pr-4x">{children}</div>
            <div className="hc8-clr-disabled hc8-pa-4x">© 2026 {appName}</div>
            {termAndConditionsUrl && (
              <a
                className="hc8-clr-placeholder hc8-pa-4x hc8-mr-3x"
                href={termAndConditionsUrl}
                target="_blank"
                rel="noreferrer"
              >
                Terms and Conditions
              </a>
            )}
          </StyledFooterItems>
        </Grid.Item>
      </Grid.Container>
    </Layout.Footer>
  )
}

export default Footer
